import { differenceInCalendarDays } from 'date-fns';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { jsPDF } from 'jspdf';
import { DatePipe } from '@angular/common';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import html2canvas from 'html2canvas';
import { CompleteInspection } from 'src/app/modules/course-accreditation/models/complete-inspection.model';
import { Representatives } from 'src/app/modules/course-accreditation/models/representatives.model';
import { RepresentativeOfficerList } from 'src/app/modules/course-accreditation/models/representative-officer-list.model';
import { Officer } from 'src/app/modules/course-accreditation/models/officer.model';
import { ListTamOccupation } from 'src/app/modules/course-accreditation/models/list-tam-occupation.model';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { InspectionService } from 'src/app/modules/course-accreditation/services/inspection.service';
import { RepresentativeComponent } from 'src/app/modules/course-accreditation/components/representative/representative.component';

@Component({
  selector: 'app-complete-inspection',
  templateUrl: './complete-inspection.component.html',
  styleUrls: ['./complete-inspection.component.scss']
})
export class CompleteInspectionComponent implements OnInit {

  completeInspectForm: FormGroup;

  //#region  Model
  completeInspection: CompleteInspection;
  completeInspectionList: CompleteInspection;
  completeInspectionListByType: CompleteInspection;
  representativeList: Representatives[] = [];
  representativeOfficerList: RepresentativeOfficerList[] = [];
  detailsSummaryReport: any;
  scrutinyReport: any;

  officersList: Officer[] = [];
  officers1List: Officer[] = [];
  officers2List: Officer[] = [];
  officers3List: Officer[] = [];

  officers1ListIndexing: Officer[] = [];
  officers2ListIndexing: Officer[] = [];
  officers3ListIndexing: Officer[] = [];
  nsdaUsers: Officer[] = [];
  listTamOccupation: ListTamOccupation[] = [];
  inspectionId: number;
  stpMainId: number;
  isRegistrationInspectionRequired: any;
  inspectionRegistrationReportId: any;
  isRenewed: boolean;
  isReapplied: boolean;
  //#endregion

  inspectionConductedDate: Date;
  nsdaOfficerId: string;
  officer1Id: string;
  officer2Id: string;
  officer3Id: string;

  isOfficer1Present: boolean;
  isOfficer2Present: boolean;
  isOfficer3Present: boolean;

  viewPdf: boolean = false;

  saveButtonDisabled = false;
  submitButtonDisabled = false;

  isCorrectionRequired: boolean = false;
  correctionRemarks: string;
  applicationPermissions = applicationPermissions;
  today = new Date();

  //#region report summary
  stpName: string;
  stpId: string;
  applicationId: string;
  dateOfApplication: string | null;
  dateOfInspectionConducted: string | null;
  inspectionConductedBy1: string;
  inspectionConductedBy2: string;
  inspectionConductedBy3: string;
  inspectionConductedBy4: string;
  //#endregion

  //#region constructor
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    private inspectionStorageService: InspectionStorageService,
    private inspectionService: InspectionService,
    private route: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private datepipe: DatePipe
  ) {
    //#region pass parameter to router link
    let inspectionId = this.route.snapshot.params.inspectionId;
    this.inspectionId = inspectionId;
    this.createForm({} as any);
    this.onStpCompleteInspectionByInspectionId(inspectionId);
    this.onCompleteInspectionRepresentativeList();
    this.getScrutinyResult(inspectionId);
    //#endregion
  }
  //#endregion

  //#region onInit
  ngOnInit(): void {}
  //#endregion

  //#region create form
  createForm(data: any) {
    let nsdaOfficerName = {} as Officer;
    if (data?.nsdaOfficerName) {
      nsdaOfficerName.id = data?.nsdaOfficerId;
      nsdaOfficerName.name = data?.nsdaOfficerName;
      this.nsdaUsers.push(nsdaOfficerName);
    }

    //getRemarks
    // this.inspectionStorageService
    //   .getSummaryOccupationListByInspectionId(this.inspectionId)
    //   .subscribe({
    //     next: (res) => {
    //       if (res?.data?.length > 0) {
    //         this.correctionRemarks =
    //           res?.data[0]?.inspectionDetailsForIndividualUser?.correctionRemarks;
    //       }
    //     },
    //   });

    //#region Officer 1 list
    let officer = {} as Officer;
    if (data?.officer1Name) {
      officer.id = data?.officer1Id;
      officer.name = data?.officer1Name;
      this.officersList.push(officer);
    }

    if (data?.officer2Name) {
      officer = {} as Officer;
      officer.id = data?.officer2Id;
      officer.name = data?.officer2Name;
      this.officersList.push(officer);
    }

    if (data?.officer3Name) {
      officer = {} as Officer;
      officer.id = data?.officer3Id;
      officer.name = data?.officer3Name;
      this.officersList.push(officer);
    }
    //#endregion

    this.officers1List = this.officersList;
    this.officers2List = this.officersList;
    this.officers3List = this.officersList;

    //#region Form control
    this.completeInspectForm = this.fb.group({
      //General Info
      stpOrSacName: data?.name,
      stpOrSacId: data?.registrationNo,
      applicationId: data?.applicationId,
      DateOfApplication: data?.applicationDate,

      inspectionConductedDate: [null, Validators.required],
      gpsLocation: [null],
      nsdaOfficerId: [null, Validators.required],

      officer1Id: [null],
      officer2Id: [null],
      officer3Id: [null],

      inspectionConductedBy1: [null],
      inspectionConductedBy2: [null],
      inspectionConductedBy3: [null],
      inspectionConductedBy4: [null],

      representatives1Id: [null],
      representatives2Id: [null],
      representatives3Id: [null],
    });
  }
  //#endregion

  //#region its for checkRepresentativeAvailable method
  get representatives1Id() {
    return this.completeInspectForm.get('representatives1Id');
  }

  get representatives2Id() {
    return this.completeInspectForm.get('representatives2Id');
  }

  get representatives3Id() {
    return this.completeInspectForm.get('representatives3Id');
  }
  //#endregion

  //#region Submit form
  submitForm() {
    if (this.completeInspectForm.invalid) {
      this.completeInspectForm.markAllAsTouched();
      this.notification.warning('Warning!', 'Please input all required fields');
      return;
    }
    if (!this.representativeList[0]?.name) {
      this.notification.info(
        'Info!',
        'Please add at least one representative to save'
      );
      return;
    }

    let inspectionId = this.route.snapshot.params.inspectionId;
    this.completeInspection = this.completeInspectForm.value;
    this.completeInspection.inspectionId = inspectionId;
    if (this.representativeList[0]?.name) {
      this.completeInspection.representatives1Id =
        this.representativeList[0].id == null
          ? 0
          : this.representativeList[0].id;
    }
    if (this.representativeList[1].name) {
      this.completeInspection.representatives2Id =
        this.representativeList[1].id == null
          ? 0
          : this.representativeList[1].id;
    }
    if (this.representativeList[2].name) {
      this.completeInspection.representatives3Id =
        this.representativeList[2].id == null
          ? 0
          : this.representativeList[2].id;
    }
    if (this.representativeList[0].name) {
      this.saveButtonDisabled = true;
      this.inspectionStorageService
        .saveCompleteInspection(this.completeInspection)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.notification.success('Success!', response.message);
            } else {
              this.notification.error('Failed!', response.message);
            }
            this.saveButtonDisabled = false;
          },
          error: (error) => {
            this.notification.error('Failed', error);
            this.saveButtonDisabled = false;
          },
        });
    } else {
      this.notification.error(
        'Save failed!',
        'Please add at least one representative from the + button'
      );
    }
  }
  //#endregion

  //#region On select Officer 1
  onSelectOfficer1(id: any): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region On select Officer 2
  onSelectOfficer2(id: number): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region On select Officer 2
  onSelectOfficer3(id: number): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region get Complete inspection by inspection id
  onStpCompleteInspectionByInspectionId(inspectionId: number) {
    this.inspectionStorageService.getStpCompleteInspectionByInspectionId(inspectionId)
      .subscribe({
        next: (res) => {
          if(res?.success){
            this.completeInspectionList = res.data;
            this.stpMainId = res.data?.stpMainId;
            this.isRegistrationInspectionRequired = res.data?.isRegistrationInspectionRequired;
            this.inspectionRegistrationReportId = res?.data?.inspectionRegistrationReportId;
            this.isRenewed = res?.data?.isRenewed;
            this.isReapplied = res?.data?.isReapplied;

            this.buildGridArray(res.data?.representativeOfficerList);

            if (this.isRegistrationInspectionRequired) {
              this.listTamOccupation.push({
                applicationType: 'NA',
                occupationName: 'STP/SAC Registration',
                inspectionResultId: null,
                occupationLevel: '',
                stpMainId: this.stpMainId,
                type: 'STP',
              });
            }

            this.createForm(res.data);

            this.inspectionConductedDate = res.data?.inspectionConductedDate;
            this.completeInspectForm.get('inspectionConductedDate')?.patchValue(res.data?.inspectionConductedDate);

            this.nsdaOfficerId = res.data?.nsdaOfficerId;
            this.completeInspectForm.get('nsdaOfficerId')?.patchValue(res.data?.nsdaOfficerId);

            this.isOfficer1Present = res.data?.isOfficer1Present;
            if (this.isOfficer1Present) {
              this.officer1Id = res.data?.officer1Id;
              this.completeInspectForm.get('officer1Id')?.patchValue(res.data?.officer1Id);
            }

            this.isOfficer2Present = res.data?.isOfficer2Present;
            if (this.isOfficer2Present) {
              this.officer2Id = res.data?.officer2Id;
              this.completeInspectForm.get('officer2Id')?.patchValue(res.data?.officer2Id);
            }

            this.isOfficer3Present = res.data?.isOfficer3Present;
            if (this.isOfficer3Present) {
              this.officer3Id = res.data?.officer3Id;
              this.completeInspectForm.get('officer3Id')?.patchValue(res.data?.officer3Id);
            }

            this.fillAllOfficerDDL();

            this.stpName = this.completeInspectionList.name;
            this.stpId = this.completeInspectionList.registrationNo;
            this.applicationId = this.completeInspectionList.applicationId;
            this.dateOfApplication = this.datepipe.transform(this.completeInspectionList.applicationDate, 'dd/MM/yyyy');
            this.dateOfInspectionConducted = this.datepipe.transform(this.inspectionConductedDate, 'dd/MM/yyyy');
            this.inspectionConductedBy1 = this.completeInspectionList.nsdaOfficerName;
            this.inspectionConductedBy2 = this.completeInspectionList.officer1Name;
            this.inspectionConductedBy3 = this.completeInspectionList.officer2Name ? this.completeInspectionList.officer2Name : 'NA';
            this.inspectionConductedBy4 = this.completeInspectionList.officer3Name ? this.completeInspectionList.officer3Name : 'NA';
          }else{
            this.notification.warning('Warning!', res?.message);
          }
        },
      });
  }

  fillAllOfficerDDL() {
    let officer1Id = this.completeInspectForm.value.officer1Id;
    let officer2Id = this.completeInspectForm.value.officer2Id;
    let officer3Id = this.completeInspectForm.value.officer3Id;

    this.officers1List = this.officersList
      .filter((w) => w.id != officer2Id)
      .filter((w) => w.id != officer3Id);
    this.officers2List = this.officersList
      .filter((w) => w.id != officer1Id)
      .filter((w) => w.id != officer3Id);
    this.officers3List = this.officersList
      .filter((w) => w.id != officer1Id)
      .filter((w) => w.id != officer2Id);
  }

  //#region build grid
  buildGridArray(representativeList: Representatives[]) {
    if (representativeList?.length > 0) {
      if (
        this.representativeList[0]?.name == '' ||
        this.representativeList[0]?.id != representativeList[0]?.id
      ) {
        let representatives = {} as Representatives;
        representatives.id =
          representativeList[0]?.id !== undefined
            ? representativeList[0]?.id
            : 0;
        representatives.name =
          representativeList[0]?.name !== undefined
            ? representativeList[0]?.name
            : '';
        representatives.designation =
          representativeList[0]?.designation !== undefined
            ? representativeList[0]?.designation
            : '';
        representatives.phone =
          representativeList[0]?.phone !== undefined
            ? representativeList[0]?.phone
            : '';
        representatives.email =
          representativeList[0]?.email !== undefined
            ? representativeList[0]?.email
            : '';
        this.representativeList.shift();
        this.representativeList.unshift(representatives);
      }
    } else {
      let representatives = {} as Representatives;
      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.shift();
      this.representativeList.unshift(representatives);
    }
    if (representativeList?.length > 1) {
      if (
        this.representativeList[1].name == '' ||
        this.representativeList[1]?.id != representativeList[1]?.id
      ) {
        let representatives = {} as Representatives;
        this.completeInspectForm.patchValue({
          representatives2Id:
            representativeList[1]?.id !== undefined
              ? representativeList[1]?.id
              : null,
        });
        representatives.id =
          representativeList[1]?.id !== undefined
            ? representativeList[1]?.id
            : 0;
        representatives.name =
          representativeList[1]?.name !== undefined
            ? representativeList[1]?.name
            : '';
        representatives.designation =
          representativeList[1]?.designation !== undefined
            ? representativeList[1]?.designation
            : '';
        representatives.phone =
          representativeList[1]?.phone !== undefined
            ? representativeList[1]?.phone
            : '';
        representatives.email =
          representativeList[1]?.email !== undefined
            ? representativeList[1]?.email
            : '';
        this.representativeList.splice(1, 1);
        this.representativeList.splice(1, 0, representatives);
      }
    } else {
      let representatives = {} as Representatives;
      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.splice(1, 1);
      this.representativeList.splice(1, 0, representatives);
    }
    if (representativeList?.length > 2) {
      if (
        this.representativeList[2].name == '' ||
        this.representativeList[2]?.id != representativeList[2]?.id
      ) {
        let representatives = {} as Representatives;
        this.completeInspectForm.patchValue({
          representatives3Id: representativeList[2]?.id,
        });
        representatives.id = representativeList[2]?.id;
        representatives.name = representativeList[2]?.name;
        representatives.designation = representativeList[2]?.designation;
        representatives.phone = representativeList[2]?.phone;
        representatives.email = representativeList[2]?.email;
        this.representativeList.splice(2, 1);
        this.representativeList.push(representatives);
      }
    } else {
      let representatives = {} as Representatives;

      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.splice(2, 1);
      this.representativeList.push(representatives);
    }
    if (this.representativeList[0].name) {
      this.completeInspectForm.patchValue({
        representatives1Id: representativeList[0]?.id,
      });
    }
    if (this.representativeList[1].name) {
      this.completeInspectForm.patchValue({
        representatives2Id: representativeList[1]?.id,
      });
    }
    if (this.representativeList[2].name) {
      this.completeInspectForm.patchValue({
        representatives3Id: representativeList[2]?.id,
      });
    }
  }
  //#endregion

  //#region Complete inspection by inspection type
  onCompleteInspectionByInspectionType(type: string) {
    this.inspectionStorageService
      .getCompleteInspectionByInspectionType(type)
      .subscribe({
        next: (res) => {
          this.completeInspectionListByType = res.data;
        },
      });
  }
  //#endregion

  //#region Complete inspection by inspection id
  onCompleteInspectionRepresentativeList() {
    this.inspectionService.representativeList.subscribe(
      (res) => (this.representativeList = res)
    );

    for (let i = this.representativeList.length; i < 3; i++) {
      this.addRow();
    }
    this.inspectionService.setRepresentatives(this.representativeList);
  }
  addRow() {
    let representatives = {} as Representatives;
    representatives.name = '';
    representatives.designation = '';
    representatives.phone = '';
    representatives.email = '';
    this.representativeList.push(representatives);
  }
  //#endregion

  //#region  Modal
  createCustomButtonModal(): void {
    this.inspectionService.representativeList.subscribe((res) => {
      this.representativeList = res;
      this.RepresentativeIds();
    });
    const modal: NzModalRef = this.modal.create({
      nzContent: RepresentativeComponent,
      nzClosable: false,
      nzOkText: null,
      nzWidth: 1000,
    });
  }

  //#region check representative if anyone there
  checkRepresentativeAvailable(): boolean {
    return !!(this.representatives1Id?.value != null);
  }
  //#endregion

  //#region to get representative ids from grid
  RepresentativeIds() {
    this.representativeList.forEach((item, index) => {
      if (item.id != null) {
        if (index === 0) {
          this.completeInspectForm
            .get('representatives1Id')
            ?.patchValue(item.id);
        } else if (index === 1) {
          this.completeInspectForm
            .get('representatives2Id')
            ?.patchValue(item.id);
        } else if (index === 2) {
          this.completeInspectForm
            .get('representatives3Id')
            ?.patchValue(item.id);
        }
      }
    });
  }
  //#endregion

  //#region remove grid item
  removeField(index: number) {
    this.representativeList.splice(index, 1);
    let id = 'representatives' + 1 + 'Id';
    this.completeInspectForm.get(id)?.setValue(null);
    this.representativeList.push({
      name: '',
      phone: '',
      email: '',
      designation: '',
      id: null,
    });
    if (this.representativeList[0].name) {
      this.completeInspectForm.patchValue({
        representatives1Id: this.representativeList[0].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives1Id: null });
    }
    if (this.representativeList[1].name) {
      this.completeInspectForm.patchValue({
        representatives2Id: this.representativeList[1].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives2Id: null });
    }
    if (this.representativeList[2].name) {
      this.completeInspectForm.patchValue({
        representatives3Id: this.representativeList[2].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives3Id: null });
    }
  }
  //#endregion


  onEditStpSac(
    inspectionId: number,
    inspectionRegistrationReportId: number | undefined
  ): void {
    // this.router.navigate([`home/course-accreditation-inspection-report/course-acc-inspection-report/${inspectionId}/${id}`]);
    this.router.navigate(
      [`home/stp-registration/stp-sac-inspection-report/${inspectionId}`],
      {
        queryParams: {
          stpMainId: this.stpMainId,
          inspectionRegistrationReportId: inspectionRegistrationReportId,
          isRenewed: this.isRenewed,
          isReapplied: this.isReapplied,
        },
      }
    );
  }

  onViewStpSac(inspectionId: number): void {
    this.router.navigate(
      // [`home/course-accreditation/stp-sac-inspection-report/${inspectionId}`],
      // { queryParams: { inspectionId: this.inspectionId } }
      [
        `home/stp-registration/stp-sac-inspection-report-preview/${this.inspectionId}`,
      ]
      // { queryParams: { inspectionId: this.inspectionId } }
    );
  }

  //#region submit complete inspection by inspection Id
  onSubmitCompleteInspection() {
    this.submitButtonDisabled = true;
    this.inspectionStorageService
      .submitStpCompleteInspection(this.inspectionId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.notification.success('Success!', res.message);
            this.inspectionRegistrationReportId = res?.data?.inspectionRegistrationReport?.id;
            this.getScrutinyResult(this.inspectionId);
          } else {
            this.notification.error('Failed!', res.message);
            this.submitButtonDisabled = false;
          }
        },
        error: (error) => {
          this.notification.error('Failed', error);
          this.submitButtonDisabled = false;
        },
      });
  }
  //#endregion

  getScrutinyResult(inspectionId: any) {
    this.inspectionStorageService
      .getInspectionReportForDownload(inspectionId)
      .subscribe((res) => {
        this.scrutinyReport = res['data'];
        if (this.scrutinyReport) {
          this.detailsSummaryReport =
            this.scrutinyReport[
              'inspectionReportsRecommendationDetailsReportPayload'
            ];
        }
      });
  }

  public export(data: any) {
    let pdfData: any | null = window.document.getElementById(data);
    if (pdfData) {
      this.notification.info('Info!', 'Downloading summary.. Please Wait!');
      pdfData.style.display = 'block';
      this.generatePDF(pdfData);
      pdfData.style.display = 'none';
    } else {
      this.notification.error('error!', 'Failed to download summary!');
    }
  }

  generatePDF(htmlContent: any) {
    html2canvas(htmlContent, { scale: 3 }).then((canvas) => {
      const imgWidth = 208;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      heightLeft -= pageHeight;
      const doc = new jsPDF('p', 'mm', 'a4');
      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(
          canvas,
          'PNG',
          0,
          position,
          imgWidth,
          imgHeight,
          '',
          'FAST'
        );
        heightLeft -= pageHeight;
      }
      doc.save('inspection-report-summary' + '.pdf');
    });
  }

  disabledDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;

}
